var map = {
	"./birds.mp3": 7043,
	"./birds.mp3.asd": 9553,
	"./busy_city.mp3": 8160,
	"./busy_city.mp3.asd": 9212,
	"./calm_waves.mp3": 7357,
	"./city_park.mp3": 3605,
	"./city_rain.mp3": 8274,
	"./city_rain.mp3.asd": 3928,
	"./duck_pond.mp3": 1869,
	"./fire.mp3": 5040,
	"./fire.mp3.asd": 8944,
	"./mexico_market.mp3": 6364,
	"./river.mp3": 4712,
	"./sea.mp3": 6383,
	"./silence.mp3": 5380,
	"./silence.mp3.asd": 7887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7046;